import {Base} from "./base";
import {isEmpty} from "@/lib/util";
import {Toast} from "vant";

class WechatService extends Base {
  constructor() {
    super(null);
    this.config = {};
    this.shareBtns = ['menuItem:share:appMessage', 'menuItem:share:timeline'];
    this.configReady = false;
  }

  /**
   * 获得token
   * @param appid
   * @returns {Promise<{}>}
   */
  async jsapiticketGet(appid) {
    const {code = '0', obj = {}} = await this.$http('smarthos.wechat.jsapiticket.get', {
      reqUrl: location.href.split('#')[0],
      appid
    });
    return code === '0' ? obj : {};
  }

  wxConfig() {
    return new Promise((resolve, reject) => {
      this.config.openTagList = ['wx-open-launch-weapp'];
      wx.config(this.config);
      wx.ready(() => {
        this.configReady = true;
        resolve();
      });
      wx.error(res => {
        this.configReady = false;
        this.config = {};
        Toast('微信jssdk配置失败，可能会影响您分享等功能的使用！' + JSON.stringify(res));
        //bus.$emit('msg','');
        reject(res);
      })
    })
  }

  async getWxConfig(appid) {
    if (isEmpty(this.config)) {
      this.config = await this.jsapiticketGet(appid)
    }
    if (appid && this.config.appId !== appid) {
      this.config = await this.jsapiticketGet(appid)
    }
    if (!this.config.appId) {
      bus.$emit('msg', '微信jssdk获取失败');
      return false;
    }
    Log('---------------config before---------------')
    await this.wxConfig().catch(e => console.error(e));
    Log('---------------config after---------------')
    return this.config;
  }


  async beforeAction(appid) {
    if (this.configReady === false) {
      await this.getWxConfig(appid);
    }
  }


  async hideAllNonBaseMenuItem(appid) {
    Log('---------------hide before-----')
    await this.beforeAction(appid);
    Log('---------------hide-----')
    if (this.config && this.config.appId) {
      wx.ready(() => {
        wx.hideAllNonBaseMenuItem();
      })
    }
  }

  async showMenuItems(appid) {
    await this.beforeAction(appid);
    if (this.config && this.config.appId) {
      wx.ready(() => {
        wx.showMenuItems({
          menuList: this.shareBtns
        });
      })
    }
  }

  async hideMenuItems(appid) {
    await this.beforeAction(appid);
    if (this.config && this.config.appId) {
      wx.ready(() => {
        wx.hideMenuItems({
          menuList: this.shareBtns
        });
      })
    }
  }

  async closeWindow(appid) {
    await this.beforeAction(appid);
    if (this.config && this.config.appId) {
      wx.ready(() => {
        wx.closeWindow();
      })
    }
  }


  /**
   * 发送给朋友
   * @param appid
   * @param options
   * @returns {Promise<void>}
   */
  async updateAppMessageShareData(appid, options) {
    await this.beforeAction(appid);
    if (this.config && this.config.appId) {
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: options.title, // 分享标题
          desc: options.desc, // 分享描述
          link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          imgUrl: options.imgUrl, // 分享图标
          success(data) {
            Log('updateAppMessageShareData-success', data)
          },
          fail(data) {
            Log('updateAppMessageShareData-fail', data)
          },
          trigger(data) {
            Log('updateAppMessageShareData-trigger', data)
          }
        })
      })
    }
  }

  /**
   * 发送到朋友圈
   * @param appid
   * @param options
   * @returns {Promise<void>}
   */
  async updateTimelineShareData(appid, options) {
    await this.beforeAction(appid);
    if (this.config && this.config.appId) {
      wx.ready(() => {
        wx.updateTimelineShareData({
          title: options.title, // 分享标题
          link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          imgUrl: options.imgUrl, // 分享图标
        })
      })
    }
  }

  async previewImage(appid, current, urls) {
    await this.beforeAction(appid);
    if (this.config && this.config.appId) {
      wx.ready(() => {
        wx.previewImage({
          current, urls
        })
      })
    }
  }


}

export const wechatService = new WechatService();
//白名单内的路径可以分享
const whiteList = [
  //index.html
  '/doc/index',
  '/2022/report/doc',
  '/2023/report/doc',
  /\/team\/(.+)?\/detail/,
  /\/doc\/article\/(.+)?/,
  '/my/recommend',
  //m.html
  '/active/bayz',
  '/active/cdyz',
  '/active/common',
  '/active/asian',
  '/download',
  '/open/alipay'
];

export function inWhiteList(fullPath) {
  let result = false;
  for (let i = 0; i < whiteList.length; i++) {
    const white = whiteList[i];
    if (typeof white === 'string') {
      result = fullPath.includes(white);
      if (result) break;
    } else {
      result = white.test(fullPath);
      if (result) break;
    }
  }
  Log('inWhiteList', fullPath, result);
  return result;
}



// WEBPACK FOOTER //
// ./src/services/wechat.js